import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description RuStore icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { RuStore } from '@sravni/design-system-icons'
 *
 * <RuStore />
 * ```
 */
var RuStore = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "RuStore", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "m16.414 14.465 2.523.629c.914.227 1.8-.458 1.8-1.393v-9.69c0-.822-.565-1.54-1.369-1.74L13.583.831a1.444 1.444 0 0 0-1.8 1.392V4.01l-3.698-.93a1.433 1.433 0 0 0-1.781 1.392V6.26l-3.782-.95A1.436 1.436 0 0 0 .736 6.705v9.69c0 .823.56 1.54 1.358 1.74l5.74 1.44a1.436 1.436 0 0 0 1.785-1.391v-1.788l.01-7.939c0-.819-.52-1.293-.708-1.439a.087.087 0 0 1-.02-.117.103.103 0 0 1 .114-.041c.763.23 1.494 1.01 1.567 1.991l.252 7.412c.009.261.19.485.443.55l-.223-.056 2.333.587a1.433 1.433 0 0 0 1.782-1.392v-1.796l-.008-7.933c0-.818-.52-1.292-.708-1.437a.086.086 0 0 1-.02-.117.103.103 0 0 1 .114-.041c.764.23 1.494 1.009 1.567 1.988l.252 7.401c.01.26.19.483.444.546l-.396-.097Z", fill: "currentColor" }))); });

export { RuStore };
//# sourceMappingURL=RuStore.js.map
